import { type TaskType, TaskTypeValues } from "@remi/enums/task-type";
import { fromEntries, isOneOf } from "@remi/ts-utils";

import { BlockingTaskTypeValues } from "./blocking-task-type";
import { DEFINITIONS_BY_TYPE, type TaskTypeDisplay } from "./task-type-definitions";

type TaskDisplay = TaskTypeDisplay & { action: string };

const BLOCKING_DISPLAY_DEFAULTS = { action: "Complete", viewCompletedTaskLabel: "View completion" };

const getTaskDisplay = (taskType: TaskType): TaskDisplay => {
  if (isOneOf(taskType, BlockingTaskTypeValues)) {
    return { ...BLOCKING_DISPLAY_DEFAULTS, ...DEFINITIONS_BY_TYPE[taskType].display };
  }
  return DEFINITIONS_BY_TYPE[taskType].display;
};

export const TaskDisplay: Record<TaskType, TaskDisplay> = fromEntries(
  TaskTypeValues.map((taskType) => [taskType, getTaskDisplay(taskType)] as const),
);
